import React, { Component } from 'react';
import Input from 'Components/Input';
import { SingleDatePicker } from 'react-dates';
import Moment from 'moment';
import TimePicker from 'rc-time-picker';
import Cx from 'classnames';
import { isCoromandel } from 'Utils/index';


export default class ChallengePriceTooltip extends Component{
    state = {
        value:"",
        valueUSD: "",
        fromDate: new Date().getTime(),
        toDate: isCoromandel() ? Moment(this.props.systemTime).add(25, 'minutes').valueOf() : Moment(this.props.systemTime).add(24, 'hours').valueOf()
    }
    changePrice = (e)=> {
        const conversionUSDObj = (this.props.currencyDetails || []).find(currencyObj => currencyObj.name === 'USD to INR');
        const isValidInput = /^\+?\d*\.?\d*$/.test(e.target.value);
        if(isValidInput) {
            this.setState({
                value: e.target.value,
                valueUSD: e.target.value && conversionUSDObj && (e.target.value / conversionUSDObj.rupee).toFixed(5) || e.target.value
            })
        }
    }
    changePriceUSD = (e) => {
        const conversionUSDObj = (this.props.currencyDetails || []).find(currencyObj => currencyObj.name === 'USD to INR');
        this.setState({
            valueUSD: e.target.value,
            value: e.target.value && conversionUSDObj && (e.target.value * conversionUSDObj.rupee).toFixed(5) || e.target.value
        })
    }
    submitPrice = (e)=> {
        e.preventDefault();
        const { fromDate, toDate } = this.state;
        const { isCPAcceptValidity } = this.props;
        this.props.submitPrice(this.state.value, '', this.state.valueUSD, '', (isCPAcceptValidity ? {
            fromDate,
            toDate
        } : {}));
    }
    render() {
        const { rfqType, systemTime, isCPAcceptValidity, hideChallengePrice } = this.props;
        const { fromDate, toDate } = this.state;

        return (
        <form onSubmit={this.submitPrice} className={Cx("bg-white box-shadow br-5 ph-20 pv-20 wt-300 triangle-bottom", {
            'ht-450': this.state.focusedFrom || this.state.focusedTo
        })}>
            {isCPAcceptValidity && <div className="mb-10 tCenter header-medium-color fSemibold fs-18">
                <div className="mb-10 tCenter header-medium-color fSemibold fs-14"> From </div>
                <div className={Cx("flex pb-10 mb-10 mt--1", {
                    'notselectable': this.props.isEditable
                })}>
                    <SingleDatePicker
                        noBorder={true}
                        displayFormat={"DD MMM YYYY"}
                        hideKeyboardShortcutsPanel={true}
                        placeholder={"From Date"}
                        numberOfMonths={2}
                        date={Moment(fromDate)} 
                        onDateChange={(from) =>{
                            const date = from.format('YYYY-MM-DD') + ' ' + Moment(fromDate).format('HH:mm');
                            this.setState({
                                fromDate: new Date(date).getTime()
                            });
                        }}
                        focused={this.state.focusedFrom} 
                        onFocusChange={({ focused }) => { this.setState({ focusedFrom: focused }) }} 
                    />
                    <TimePicker
                        showSecond={false}
                        value={Moment(fromDate)}
                        className="ht-40 wt-150 border-status-bar br-5"
                        onChange={(from) =>{
                            const date = Moment(fromDate).format('YYYY-MM-DD') + ' ' + from.format('HH:mm');
                            this.setState({
                                fromDate: new Date(date).getTime()
                            });
                        }}
                        minTime={systemTime ? new Date(systemTime) : new Date()}
                        format={'h:mm a'}
                        use12Hours
                        inputReadOnly
                    />
                </div>

                <div className="mb-10 tCenter header-medium-color fSemibold fs-14"> To </div>
                <div className={Cx("flex pb-10 mb-20 mt--1", {
                    'notselectable': this.props.isEditable
                })}>
                    <SingleDatePicker
                        noBorder={true}
                        displayFormat={"DD MMM YYYY"}
                        hideKeyboardShortcutsPanel={true}
                        placeholder={"To Date"}
                        numberOfMonths={2}
                        date={toDate && Moment(toDate) || null} 
                        onDateChange={(from) =>{
                            const date = from.format('YYYY-MM-DD') + ' ' + Moment(toDate || from).format('HH:mm');
                            debugger;
                            this.setState({
                                toDate: new Date(date).getTime()
                            });
                        }}
                        focused={this.state.focusedTo} 
                        onFocusChange={({ focused }) => { this.setState({
                            focusedTo: focused
                        }) }}
                    />
                    <TimePicker
                        showSecond={false}
                        value={toDate && Moment(toDate) || null}
                        className="ht-40 wt-150 border-status-bar br-5"
                        onChange={(from) =>{
                            const date = Moment(toDate || from).format('YYYY-MM-DD') + ' ' + from.format('HH:mm');
                            this.setState({
                                toDate: new Date(date).getTime()
                            });
                        }}
                        minTime={systemTime ? new Date(systemTime) : new Date()}
                        format={'h:mm a'}
                        use12Hours
                        inputReadOnly
                    />
                </div>

                </div>}
            <div><span className="flex"><span className="pa pl-10 pt-10">₹</span><Input placeholder="Challenge Price" className="pl-30 mb-20" onChange={this.changePrice} value={this.state.value}/></span></div>
            {rfqType === 5 && <div><span className="flex"><span className="pa pl-10 pt-10">$</span><Input placeholder="Challenge Price" className="pl-30 mb-20 wt-250" onChange={this.changePriceUSD} value={this.state.valueUSD}/></span></div>}
            {isCPAcceptValidity && <button className="ht-40 br-20 white-color bg-theme fs-16 fBold pl-15 pr-15 wt-120 mr-10" onClick={hideChallengePrice}>Cancel</button>}
            <button className="ht-40 br-20 white-color bg-theme fs-16 fBold pl-15 pr-15" onClick={this.submitPrice}>Submit  Price</button>
        </form>
        );
    }
}
